import { render, staticRenderFns } from "./distributor-form.vue?vue&type=template&id=1348f3fa"
import script from "./distributor-form.vue?vue&type=script&lang=js"
export * from "./distributor-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./distributor-form.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports